import React from 'react';
import { Stack, Box, Typography } from '@mui/material';
import { PromptMsg, AnswerMsg, TicketResponseMsg, AgentProgressMsg, TicketResponseMsgErr } from './MsgTypes';
import Logo from '../../assets/Images/logo.ico';

const Messages = ({ messages, websocket, existingWebSocket }) => {
  if (messages.length === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img src={Logo} alt="CelcomDigi Logo" style={{ width: '100px', marginBottom: '16px' }} />
        <Typography variant="h5" color="text.primary" gutterBottom>
          Welcome to TDS{process.env.REACT_APP_MODE !== 'prod' ? ' (Dev)' : ''}
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          By IT DevOps
        </Typography>
      </Box>
    );
  }

  return (
    <Stack direction="column">
      {messages.map((el, index) => {
        switch (el.type) {
          case "prompt":
            return <PromptMsg key={index} el={el} />;
          case "answer":
            return <AnswerMsg key={index} el={el} isStreaming={false} />;
          case "agent_progress":
            return <AgentProgressMsg key={index} el={el} />;
          case "sr_ticket_response":
            return <TicketResponseMsg key={index} el={el} />;
          // case "sr_ticket_error":
          //   return <TicketResponseMsgErr key={index} el={el} isError={true} />;
          default:
            return null;
        }
      })}
    </Stack>
  );
};

export default Messages;